<template>
  <Editor id="tinymce" v-model="content" :init="init"></Editor>
</template>

<script>
import tinymce from "tinymce";
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
// 都是富文本插件
import "tinymce/icons/default";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/wordcount";

export default {
  name: "TinyEditor",
  components: { Editor },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      content: "",
      init: {
        //初始化数据
        language_url: "/tinymce/langs/zh_CN.js", // 引入语言包（该语言包在public下，注意文件名称）
        language: "zh_CN", // 这里名称根据 zh-Hans.js 里面写的名称而定
        skin_url: "/tinymce/skins/ui/oxide", // 这里引入的样式
        width: '100%',
        height: 500, // 限制高度
        plugins: "link lists image code table wordcount", // 富文本插件
        promotion: false,
        toolbar:
          "bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image code | removeformat",
        branding: false, // //是否禁用“Powered by TinyMCE”
        menubar: true, //顶部菜单栏显示
        // paste_convert_word_fake_lists: false, // 插入word文档需要该属性
        content_css: "/tinymce/skins/content/default/content.css", //以css文件方式自定义可编辑区域的css样式，css文件需自己创建并引入
        setup: (editor) => {
          // 如果你需要在编辑器初始化之前设置内容，可以使用setContent
          editor.on('init', () => {
					editor.setContent(this.value)    
				})
        },
        images_upload_handler: (blobInfo,success) =>
          new Promise((resolve, reject) => {
            // console.log(blobInfo.blob());
            // 上传图片需要，FormData 格式的文件；
            const formDataUp = new FormData();
            // img  是接口需要的上传的属性名，一般属性名是 file
            formDataUp.append("file", blobInfo.blob());
            // // console.log(formDataUp);
            axios({
              method: "post",
              url: process.env.VUE_APP_BASE_API + "/api/file/uploadOss",
              data: formDataUp,
              headers: {
                system: 1,
              },
            }).then((res) => {
              console.log(res);
              success(res.data.data.url);
            });
          }),
      },
    };
  },
  watch: {
    value(newVal) {
      //this.content = newValue;
      //用户vue绑定回显
      // if (this.isInit) {
      //   this.isInit = false;
      //   this.getContent();
      //   this.$nextTick(() => {
      //     const editor = tinymce.get("tinymce");
      //     editor.activeEditor.getContent()
      //     editor.setContent(newVal);
      //   });
      // }
      this.content = newVal;
    },
    content(newValue) {
      this.$emit("input", newValue);
    },
  },
  mounted() {
    tinymce.init({
      // setup: (editor) => {
      //   // 如果你需要在编辑器初始化之前设置内容，可以使用setContent
      //   editor.setContent('这里是你想要回显的内容');
      //   console.log(editor, 'editor');
      // },
    });

    // this.$nextTick(() => {
    //   const editor = tinymce.get("tinymce");
    //   editor.setContent('这里是你想要回显的内容');
    // });
  },
  methods: {
    getContent() {
      var cnt = tinymce.editors["tinymce"].getContent();
      console.log(cnt);
    },
  },
};
</script>
<style></style>
